import { useState, useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ImageCarousel({ images = [] }) {
  const [emblaRef, embla] = useEmblaCarousel({ loop: true });
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!embla) return;
    const onSelect = () => setIdx(embla.selectedScrollSnap());
    embla.on("select", onSelect);
    onSelect();
    return () => { embla.off("select", onSelect); };
  }, [embla]);

  if (!images.length) return null;

  return (
    <div className="relative">
      <div className="overflow-hidden rounded-2xl" ref={emblaRef} data-testid="image-carousel">
        <div className="flex">
          {images.map((img, i) => (
            <div key={`slide-${img}-${i}`} className="min-w-0 flex-[0_0_100%] aspect-[16/10]">
              <img src={img} alt="" className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>
      {images.length > 1 && (
        <>
          <button
            data-testid="carousel-prev"
            onClick={() => embla?.scrollPrev()}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-canvas/90 backdrop-blur rounded-full p-2 hover:bg-canvas transition-colors"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
          <button
            data-testid="carousel-next"
            onClick={() => embla?.scrollNext()}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-canvas/90 backdrop-blur rounded-full p-2 hover:bg-canvas transition-colors"
          >
            <ChevronRight className="h-5 w-5" />
          </button>
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5">
            {images.map((img, i) => (
              <button
                key={`dot-${img}-${i}`}
                onClick={() => embla?.scrollTo(i)}
                className={`h-1.5 rounded-full transition-all ${idx === i ? "w-6 bg-canvas" : "w-1.5 bg-canvas/50"}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
